import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const GoogleSheetsIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props} customFill={preserveColor}>
    <g clipPath="url(#gsheets-a)">
      <mask
        id="gsheets-b"
        width="18"
        height="25"
        x="7"
        y="3"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
      >
        <path
          fill="#fff"
          d="M18.174 3.358H8.936c-.896 0-1.63.745-1.63 1.655v20.974c0 .91.734 1.655 1.63 1.655h14.128c.896 0 1.63-.745 1.63-1.655V9.98l-6.52-6.623Z"
        />
      </mask>
      <g mask="url(#gsheets-b)">
        <path
          fill="#0F9D58"
          d="M18.174 3.358H8.936c-.896 0-1.63.745-1.63 1.655v20.974c0 .91.734 1.655 1.63 1.655h14.128c.896 0 1.63-.745 1.63-1.655V9.98L20.89 7.22l-2.716-3.863Z"
        />
      </g>
      <mask
        id="gsheets-c"
        width="18"
        height="25"
        x="7"
        y="3"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
      >
        <path
          fill="#fff"
          d="M18.174 3.358H8.936c-.896 0-1.63.745-1.63 1.655v20.974c0 .91.734 1.655 1.63 1.655h14.128c.896 0 1.63-.745 1.63-1.655V9.98l-6.52-6.623Z"
        />
      </mask>
      <g mask="url(#gsheets-c)">
        <path
          fill="#F1F1F1"
          d="M11.653 15.224v8.003h8.694v-8.003h-8.694Zm3.804 6.9H12.74v-1.38h2.717v1.38Zm0-2.209H12.74v-1.38h2.717v1.38Zm0-2.207H12.74v-1.38h2.717v1.38Zm3.803 4.415h-2.716v-1.38h2.716v1.38Zm0-2.208h-2.716v-1.38h2.716v1.38Zm0-2.207h-2.716v-1.38h2.716v1.38Z"
        />
      </g>
      <mask
        id="gsheets-d"
        width="18"
        height="25"
        x="7"
        y="3"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
      >
        <path
          fill="#fff"
          d="M18.174 3.358H8.936c-.896 0-1.63.745-1.63 1.655v20.974c0 .91.734 1.655 1.63 1.655h14.128c.896 0 1.63-.745 1.63-1.655V9.98l-6.52-6.623Z"
        />
      </mask>
      <g mask="url(#gsheets-d)">
        <path
          fill="url(#gsheets-e)"
          d="m18.65 9.496 6.044 6.138V9.98l-6.044-.485Z"
        />
      </g>
      <mask
        id="gsheets-f"
        width="18"
        height="25"
        x="7"
        y="3"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
      >
        <path
          fill="#fff"
          d="M18.174 3.358H8.936c-.896 0-1.63.745-1.63 1.655v20.974c0 .91.734 1.655 1.63 1.655h14.128c.896 0 1.63-.745 1.63-1.655V9.98l-6.52-6.623Z"
        />
      </mask>
      <g mask="url(#gsheets-f)">
        <path
          fill="#87CEAC"
          d="M18.173 3.358v4.967c0 .915.73 1.656 1.63 1.656h4.89l-6.52-6.623Z"
        />
      </g>
      <mask
        id="gsheets-g"
        width="18"
        height="25"
        x="7"
        y="3"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
      >
        <path
          fill="#fff"
          d="M18.174 3.358H8.936c-.896 0-1.63.745-1.63 1.655v20.974c0 .91.734 1.655 1.63 1.655h14.128c.896 0 1.63-.745 1.63-1.655V9.98l-6.52-6.623Z"
        />
      </mask>
      <g mask="url(#gsheets-g)">
        <path
          fill="#fff"
          fillOpacity=".2"
          d="M8.936 3.358c-.896 0-1.63.745-1.63 1.655v.138c0-.91.734-1.655 1.63-1.655h9.238v-.138H8.936Z"
        />
      </g>
      <mask
        id="gsheets-h"
        width="18"
        height="25"
        x="7"
        y="3"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
      >
        <path
          fill="#fff"
          d="M18.174 3.358H8.936c-.896 0-1.63.745-1.63 1.655v20.974c0 .91.734 1.655 1.63 1.655h14.128c.896 0 1.63-.745 1.63-1.655V9.98l-6.52-6.623Z"
        />
      </mask>
      <g mask="url(#gsheets-h)">
        <path
          fill="#263238"
          fillOpacity=".2"
          d="M23.064 27.504H8.936c-.896 0-1.63-.745-1.63-1.655v.138c0 .91.734 1.655 1.63 1.655h14.128c.896 0 1.63-.745 1.63-1.655v-.138c0 .91-.734 1.655-1.63 1.655Z"
        />
      </g>
      <mask
        id="gsheets-i"
        width="18"
        height="25"
        x="7"
        y="3"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
      >
        <path
          fill="#fff"
          d="M18.174 3.358H8.936c-.896 0-1.63.745-1.63 1.655v20.974c0 .91.734 1.655 1.63 1.655h14.128c.896 0 1.63-.745 1.63-1.655V9.98l-6.52-6.623Z"
        />
      </mask>
      <g mask="url(#gsheets-i)">
        <path
          fill="#263238"
          fillOpacity=".1"
          d="M19.803 9.98c-.9 0-1.63-.74-1.63-1.655v.138c0 .915.73 1.656 1.63 1.656h4.89V9.98h-4.89Z"
        />
      </g>
      <path
        fill="url(#gsheets-j)"
        d="M18.174 3.358H8.936c-.896 0-1.63.745-1.63 1.655v20.974c0 .91.734 1.655 1.63 1.655h14.128c.896 0 1.63-.745 1.63-1.655V9.98l-6.52-6.623Z"
      />
    </g>
    <defs>
      <radialGradient
        id="gsheets-j"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(2803.75 0 0 2847.92 62.391 51.355)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity=".1" />
        <stop offset="1" stopColor="#fff" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="gsheets-e"
        x1="320.863"
        x2="320.863"
        y1="62.193"
        y2="623.326"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#263238" stopOpacity=".2" />
        <stop offset="1" stopColor="#263238" stopOpacity=".02" />
      </linearGradient>
      <clipPath id="gsheets-a">
        <path fill="#fff" d="M7 3h18v25H7z" />
      </clipPath>
    </defs>
  </BaseIcon>
);
